import { inject, ref } from "vue";
import {
    applyCoupon as applyCouponRequest,
    removeCoupon as removeCouponRequest,
} from "../api/coupons";

export function useCoupon() {
    const emitter = inject<any>("mitt");
    const loading = ref(false);

    function applyCoupon(inputs: { coupon_code: string }) {
        if (loading.value) {
            return;
        }

        loading.value = true;

        applyCouponRequest(inputs)
            .then((data) => {
                emitter.emit("couponApplied", data);
            })
            .catch((error) => {
                if (
                    typeof error.response !== "undefined" &&
                    Object.prototype.hasOwnProperty.call(
                        error.response,
                        "data",
                    ) &&
                    Object.prototype.hasOwnProperty.call(
                        error.response.data,
                        "errors",
                    )
                ) {
                    emitter.emit("couponError", {
                        data: error.response.data,
                    });
                }
            })
            .finally(() => (loading.value = false));
    }

    function removeCoupon(discount: any) {
        if (loading.value) {
            return;
        }

        loading.value = true;

        removeCouponRequest(discount.id)
            .then((data) => {
                emitter.emit("couponRemoved", data);
            })
            .finally(() => (loading.value = false));
    }

    return {
        loading,
        applyCoupon,
        removeCoupon,
    };
}
